export enum DocumentPropertyKey {

  BANK_ACCOUNT = 'BANK_ACCOUNT',
  INVOICE_SUMMARY_MSG = 'INVOICE_SUMMARY_MSG',
  DELIVERY_NOTE_SUMMARY_MSG = 'DELIVERY_NOTE_SUMMARY_MSG',
  PROFORMA_INVOICE_SUMMARY_MSG = 'PROFORMA_INVOICE_SUMMARY_MSG',
  COST_ESTIMATE_SUMMARY_MSG = 'COST_ESTIMATE_SUMMARY_MSG',
  CANCELLATION_SUMMARY_MSG = 'CANCELLATION_SUMMARY_MSG',
  LANGUAGE_CODE = 'LANGUAGE_CODE',
}
